import { ThunkAction } from "redux-thunk";
import { RootState } from "../../store";
import { AnyAction } from "redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../actionsCreators/messageActions";
import { AdministrationGeneralPut } from "../../types/AdministrationGeneral";
import AdministrationGeneralService from "../../services/administration/general";
import { NEXT_NUMBER_UPDATED } from "../../lib/constants";

export const editNextNumber =
  (
    req: AdministrationGeneralPut
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await AdministrationGeneralService.edit(req);

      dispatch(setSuccessMessage(NEXT_NUMBER_UPDATED));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };
